import React from 'react';

import { ICellRendererParams } from 'ag-grid-community';
import { emptyCellFormatter } from 'src/util/grid/cellFormatter';
import { getYYYYMMDDUTCStrFromTimestamp } from 'src/util/grid/cellGetter';
import { getTerritoryFlagRenderer } from 'src/util/grid/cellRenderer';
import { dateFilterOptions } from 'src/util/grid/filter';
import { dateComparator, dateFilterComparator } from 'src/util/grid/sort';

export const vendorCodesColDefs = [
    {
        headerName: 'Catalog code',
        field: 'catalogVendorCode',
        filter: 'agTextColumnFilter'
    },
    {
        headerName: 'Royalty code',
        field: 'royaltyVendorCode',
        filter: 'agTextColumnFilter'
    },
    {
        headerName: 'Service',
        field: 'serviceName'
    },
    {
        headerName: 'Territory',
        field: 'territoryName',
        filter: 'agTextColumnFilter',
        cellRenderer: (params: ICellRendererParams) => getTerritoryFlagRenderer(params, false)
    },
    {
        headerName: 'Mapping start',
        field: 'startDate',
        comparator: dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: {
            filterOptions: dateFilterOptions,
            defaultOption: 'greaterThanOrEqual',
            comparator: dateFilterComparator,
            includeBlanksInLessThan: true,
            includeBlanksInGreaterThan: true
        },
        valueGetter: getYYYYMMDDUTCStrFromTimestamp
    },
    {
        headerName: 'Mapping end',
        field: 'endDate',
        comparator: dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: {
            filterOptions: dateFilterOptions,
            defaultOption: 'lessThanOrEqual',
            comparator: dateFilterComparator,
            includeBlanksInLessThan: true,
            includeBlanksInGreaterThan: true
        },
        valueFormatter: emptyCellFormatter,
        valueGetter: getYYYYMMDDUTCStrFromTimestamp
    }
];
